import { render, staticRenderFns } from "./AdminEmpty.vue?vue&type=template&id=18b7e935&scoped=true&"
import script from "./AdminEmpty.vue?vue&type=script&lang=ts&"
export * from "./AdminEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b7e935",
  null
  
)

export default component.exports